export default {
  emails: [],
  email: undefined,
};
